import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/Header.css';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [active, setActive] = useState('hero');
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 50);
            const ids = ['hero', 'about', 'skills', 'projects', 'experience', 'contact'];
            for (const id of ids) {
                const el = document.getElementById(id);
                if (el) {
                    const r = el.getBoundingClientRect();
                    if (r.top <= 120 && r.bottom >= 120) { setActive(id); break; }
                }
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const navTo = (id) => {
        setActive(id);
        setMobileOpen(false);
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    const links = ['about', 'skills', 'projects', 'experience'];

    return (
        <>
            <motion.header
                className={`header ${scrolled ? 'scrolled' : ''}`}
                initial={{ y: -80, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
                <div className="container header-inner">
                    <a href="#hero" className="brand" onClick={(e) => { e.preventDefault(); navTo('hero'); }}>
                        Nanda<span className="brand-dot">.</span>
                    </a>

                    <nav className="nav-desktop">
                        {links.map(id => (
                            <a
                                key={id}
                                href={`#${id}`}
                                className={`nav-link ${active === id ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); navTo(id); }}
                            >
                                {id.charAt(0).toUpperCase() + id.slice(1)}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            className="btn primary nav-cta"
                            onClick={(e) => { e.preventDefault(); navTo('contact'); }}
                        >
                            Contact
                        </a>
                    </nav>

                    <button
                        className={`hamburger ${mobileOpen ? 'open' : ''}`}
                        onClick={() => setMobileOpen(!mobileOpen)}
                        aria-label="Menu"
                    >
                        <span /><span /><span />
                    </button>
                </div>
            </motion.header>

            <AnimatePresence>
                {mobileOpen && (
                    <motion.div
                        className="mobile-nav"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <nav>
                            {[...links, 'contact'].map((id, i) => (
                                <motion.a
                                    key={id}
                                    href={`#${id}`}
                                    className={active === id ? 'active' : ''}
                                    onClick={(e) => { e.preventDefault(); navTo(id); }}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: i * 0.06 }}
                                >
                                    {id.charAt(0).toUpperCase() + id.slice(1)}
                                </motion.a>
                            ))}
                        </nav>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default Header;